import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { yup } from '../services/yup';

export const usePhoneNumberValidation = () => {
  const intl = useIntl();

  return useMemo(
    () => yup.string()
      .required(intl.formatMessage({ id: 'common.errors.required' }))
      .phoneNumberLength(intl.formatMessage({ id: 'common.errors.phoneNumber.length' })),
    [intl],
  );
};
